<script lang="ts">
  import type { Models } from '@smartlinkdev/types';
  import { error } from '@sveltejs/kit';
  import { get } from 'radash';
  import { onMount } from 'svelte';
  import { beforeNavigate } from '$app/navigation';
  import LocationDetailsTooltip from '$lib/components/LocationDetailsTooltip.svelte';
  import {
    forceRoveMap,
    mapReady,
    locations,
    mapInstance,
    hideControls,
    venue,
    currentLocation,
  } from '$lib/stores';
  import { activeLanguage } from '$lib/stores/languages';
  import type { PageData } from './$types';

  export let data: PageData;
  let location: Models.Location | undefined;
  let ready = false;

  beforeNavigate(() => {
    if ($venue.settings.mapType === 'rove' || $forceRoveMap) {
      if ($mapInstance) {
        $mapInstance.removeLocationHighlight(location.id);
      }
    }
  });

  onMount(() => {
    if ($mapReady) {
      showLocationDetails();
    }
    ready = true;
  });

  mapReady.subscribe((val) => {
    if (val && ready) {
      showLocationDetails();
    }
  });

  $: {
    location = $locations.find((loc) => loc.id === data.locationId);
    $currentLocation = location;
    if ($mapReady && ready) {
      showLocationDetails();
    }
  }

  const showLocationDetails = () => {
    if (!$mapInstance) {
      return;
    }

    const found = $locations.find((loc) => loc.id === data.locationId);
    if (!found) {
      throw error(404, 'Not found');
    }
    const buildingHighlightColor = get($venue, 'settings.mapboxSettings.buildingHighlightColor', '#cc0000');
    $mapInstance.highlightLocationById(found.id, buildingHighlightColor);

    const tempEl = document.createElement('div');
    const tooltipComponent = new LocationDetailsTooltip({
      target: tempEl,
      props: {
        location: found,
      },
    });
    const oldTooltipHTML = tempEl.innerHTML;
    const tooltipHTML = tempEl;

    if ($venue.settings.mapType === 'mapbox' && !$forceRoveMap) {
      const locationData = $mapInstance.getLocationCenter(found.id);
      if (locationData) {
        $mapInstance.flyinToLocationById(found.id);

        if (!$hideControls) {
          const marker = $mapInstance.setMarker({
            html: oldTooltipHTML,
            coord: {
              lng: locationData.center[0],
              lat: locationData.center[1],
            },
          }, true);

          activeLanguage.subscribe(async () => {
            tooltipComponent.$set({ location });
            const updatedEl = tooltipComponent.$$.root.children[0];
            marker.mapboxPin.setElement(updatedEl);
          });
        }
      } else {
        $mapInstance.clearMarkers();
      }
    } else {
      $mapInstance.flyinToLocationById(found.id);
      const shape = $mapInstance.getShape(found.id);
      if (!$hideControls && shape) {
        const pinId = `htmlPin-${location.id}`;
        $mapInstance.setHtmlPin({
          id: pinId,
          center: shape.center,
          element: tooltipHTML,
          floorIds: shape.shapeConfig.floorIds,
          isYouAreHere: false,
          startScale: 15,
          centered: true,
          height: 10,
        }, true);
      }
    }
  };
</script>
